export default function BenefitsSection() {
  const benefits = [
    {
      title: 'Save Time and Reduce Stress',
      description: 'Stop spending hours on bookkeeping tasks. Our El Paso bookkeeping experts handle everything from data entry to financial reporting, giving you more time to focus on what you do best - running your business.',
      icon: 'ri-time-line'
    },
    {
      title: 'Expert QuickBooks Knowledge',
      description: 'Our team is certified in QuickBooks and stays current with the latest features and best practices. We optimize your QuickBooks setup for maximum efficiency and accuracy in tracking your business finances.',
      icon: 'ri-award-line'
    },
    {
      title: 'Local El Paso Service',
      description: 'As a local bookkeeping service in El Paso, Texas, we understand the unique needs of West Texas businesses. We are familiar with local regulations and can meet in person when needed.',
      icon: 'ri-map-pin-line'
    },
    {
      title: 'Affordable and Transparent Pricing',
      description: 'Get professional bookkeeping services without breaking the bank. Our transparent pricing means no hidden fees or surprises - just reliable service at rates that work for small businesses.',
      icon: 'ri-money-dollar-circle-line'
    },
    {
      title: 'Accurate Financial Records',
      description: 'Maintain clean, organized books that give you confidence in your financial position. Our attention to detail ensures your records are always audit-ready and compliant with regulations.',
      icon: 'ri-file-chart-line'
    },
    {
      title: 'Better Business Decisions',
      description: 'Make informed decisions with timely financial insights. Our reports and analysis help you identify trends, control costs, and plan for growth with confidence.',
      icon: 'ri-lightbulb-line'
    },
    {
      title: 'Scalable Solutions',
      description: 'Whether you are a startup or an established business, our bookkeeping services grow with you. We adapt our services to match your changing needs as your El Paso business expands.',
      icon: 'ri-line-chart-line'
    },
    {
      title: 'Secure and Confidential',
      description: 'Your financial data is protected with bank-level security. We use encrypted connections and follow strict confidentiality protocols to keep your business information safe.',
      icon: 'ri-lock-line'
    }
  ];

  return (
    <section id="benefits" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Why Choose Our <strong>El Paso Bookkeeping Services</strong>?
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Discover how our professional <strong>bookkeeping services</strong> can transform your business finances and give you the clarity you need to succeed.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="flex gap-6 p-6 bg-gray-50 rounded-xl hover:bg-orange-50 transition-colors"
            >
              <div className="flex-shrink-0">
                <div className="w-14 h-14 bg-teal-500 rounded-lg flex items-center justify-center">
                  <i className={`${benefit.icon} text-white text-2xl`}></i>
                </div>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {benefit.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
